// LuxuryPage.jsx
import React from "react";
// import "./LuxuryPage.css";
import "../App.css";
import { useEnquiryModal } from "./EnquiryModal";

const LuxuryPage = () => {
  const { openModal } = useEnquiryModal();
  return (
    <div id="about" className="luxury-page">
      {/* ----------- Section 1: Luxury Launch ----------- */}
      <section className="luxury-section">
        <div className="luxury-image">
          <img
            src="../Assets/banner1.webp"
            alt="Luxury View"
          />
        </div>
        <div className="luxury-text">
          <h2 className="font-semibold">
            HADO BY BEYOND – SIØRA  
          </h2>
          <p>
            BEYOND HADO AT SIORA offers spacious 1- to 4-bedroom residences starting from 767 sq ft and priced from AED 3,000 per sq ft, delivering exceptional value in Dubai’s newest lifestyle community. Hado by Beyond Dubai Islands within 140,000 sqm of greenery, a 6 km beach, and 10 km of jogging and cycling tracks, it blends wellness, leisure, and modern living. Beyond Hado Dubai Islands with completion in Q3 2029 and a flexible 50/50 payment plan, it is an ideal beachfront investment. Meditation pockets, yoga studios, chef’s lounges, and curated retail all support a purposeful, enriched way of life in SIØRA.
          </p>
          <button onClick={openModal} className="mt-4 font-semibold border-2 rounded-md border-[#997736] text-[#997736] hover:text-white px-6 py-2 hover:bg-[#997736] transition">DOWNLOAD BROCHURE</button>
        </div>
      </section>
    </div>
  );
};

export default LuxuryPage;
